/// <reference path="../../../../../typings/index.d.ts" />
///<reference path="../../../components/baseClasses/dataMaintenanceSectionBase.ts"/>


module Meevo.Plugins.YieldManagementProgram {

    import IYMStrategy = Meevo.Plugins.YieldManagementStrategy.IYMStrategy;

    export class YmSectionBase extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<YMProgramModel> {
        public selectedStrategy: IYMStrategy;
        protected _model: YMProgramModel;

        get model() {
            return this._model;
        }

        set model(model) {
            if (model instanceof YMProgramModel) {
                this._model = model;
            } else {
                this._model = new YMProgramModel(model);
            }
        }

        public get isCreatedInCurrentLocation() {
            return this.identityService.inCentralOfficeMode() || this.identityService.isSingleLocation() || this.model.homeLocationId === this.identityService.locationId;
        }

        public modelIsValid(): boolean {
            return true;
        }

        /**
         * Creates a copy of the selected section's model and reassigns it to the model.
         * @returns {YMProgramModel}
         */
        protected createSectionModelCopy(): YMProgramModel {
            this.model.id = null;
            this.model.programId = null;

            return this.model;
        }
    }
}
